import React, { useEffect, useState } from 'react';
import { Box, Button, Container, makeStyles } from '@material-ui/core';
import { SpecialZoomLevel, Viewer, Worker } from '@react-pdf-viewer/core';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import usePage from '@/hooks/usePage.js';
import Request from '@/helpers/request.js';
import Constants from '@/constants.js';
import mainStyles from '@/assets/js/mainStyles.js';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';

const useStyles = makeStyles(mainStyles);

const Document = () => {
  const classes = useStyles();
  const [regulation, setRegulation] = useState(null);
  const { setTitle } = usePage();
  const zoomPluginInstance = zoomPlugin();
  const { CurrentScale, ZoomIn, ZoomOut } = zoomPluginInstance;

  useEffect(async () => {
    const fetchModule = async () => {
      const response = (await Request.get(`/p3d2-regulation`)).items[0];
      setRegulation(response);
      setTitle('Documentation officielle');
    };
    await fetchModule();
  }, []);

  return (
    <Container maxWidth="md">
      <Box className={classes.descRoot}>
        {regulation && (
          <div className={classes.pdfViewer}>
            {/* eslint-disable-next-line react/jsx-no-undef */}
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.3.122/build/pdf.worker.min.js">
              <div style={{ textAlign: 'center' }}>
                <ZoomOut>
                  {(props) => (
                    <Button style={{ width: 100, height: 20 }} className={classes.outlinedBtn} onClick={props.onClick}>
                      ZoomOut
                    </Button>
                  )}
                </ZoomOut>
                <CurrentScale>
                  {(props) => <span style={{ padding: 10 }}>{`${Math.round(props.scale * 100)}%`}</span>}
                </CurrentScale>
                <ZoomIn>
                  {(props) => (
                    <Button style={{ width: 100, height: 20 }} className={classes.outlinedBtn} onClick={props.onClick}>
                      ZoomIn
                    </Button>
                  )}
                </ZoomIn>
              </div>
              <Viewer
                defaultScale={SpecialZoomLevel.PageFit}
                plugins={[zoomPluginInstance]}
                fileUrl={`${Constants.BASE_URL}/${regulation.officialDocumentation.path} `}
              />
            </Worker>
          </div>
        )}
      </Box>
    </Container>
  );
};

export default Document;
